import { createFileRoute } from '@tanstack/react-router'
import BusinessReport from '@/features/business-report'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { Permissions } from '@/constants/roles-permissions'

export const Route = createFileRoute('/_authenticated/business-report')({
  component: BusinessReportRoute,
})

function BusinessReportRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.AccountingTransactionView}>
      <BusinessReport />
    </ProtectedRoute>
  )
}
